import { render } from "./Avatar.vue?vue&type=template&id=405f0876"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Content/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "405f0876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('405f0876', __exports__)) {
    api.reload('405f0876', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=405f0876", () => {
    api.rerender('405f0876', render)
  })

}


export default __exports__